<template>
  <div class="tableContainer">
    <div class="title">
      <h3 class="text">演练记录</h3>
    </div>
    <div class="searchContainer">
      <a-form>
        <a-row :gutter="6" class="searchBox">
          <a-col :span="9">
            <a-form-item>
              <a-select
                @change="changeuniversity"
                placeholder="单位"
                v-model="university"
                :disabled="disabled"
              >
                <a-select-option
                  v-for="(item, key) in universitylist"
                  :key="key"
                  :value="item.id"
                >
                  <span
                    style="display: inline-block; width: 100%"
                    :title="item.universityName"
                  >
                    {{ item.universityName }}
                  </span>
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="2">
            <a-button
              type="primary"
              @click="search"
              shape="round"
              icon="search"
              class="searchBtn"
              >查询</a-button
            >
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-row style="padding: 1vw">
      <a-col>
        <div class="tablebox">
          <a-table
            :locale="{ emptyText }"
            :columns="columns"
            :data-source="tableData"
            :pagination="false"
            rowKey="id"
          >
            <span slot="action" slot-scope="text, record">
              <a @click="seedetails(record)">查看详情</a>
            </span>
          </a-table>
        </div>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import Axios from "@/Axios";
export default {
  data() {
    return {
      universitylist: [],
      universityId: "",
      university: undefined,
      disabled: true,
      emptyText: "暂无数据",
      url: {
        alluniverrecord: "/repcomposer/repComposer/newReport",
      },
      columns: [
        {
          dataIndex: "traintime",
          title: "训练时间",
          key: "traintime",
          align: "center",
          width: 90
        },
        {
          dataIndex: "universityId_dictText",
          title: "用户名称",
          key: "universityId_dictText",
          align: "center",
          width: 90
        },
        {
          title: "活动编码",
          dataIndex: "activeCode",
          key: "activeCode",
          align: "center",
          width: 90
        },
        {
          title: "参与部门",
          dataIndex: "traindepartment",
          key: "traindepartment",
          align: "center",
          width: 90
        },
        {
          title: "参与人数",
          dataIndex: "peoplenum",
          key: "peoplenum",
          align: "center",
          width: 90
        },
        {
          title: "操作",
          key: "action",
          dataIndex: "action",
          scopedSlots: { customRender: "action" },
          align: "center",
          width: 90
        },
      ],
      tableData: [],
    };
  },
  mounted() {
    this.getselectlist();

    this.getUniversityId();
    this.getReport(this.universityId);
  },
  methods: {
    // 训练安排查看详情
    seedetails(data) {
      // console.log(data);
      this.$router.push({
        path: "/traindetails",
        query: {
          id: data.id,
          time: data.traintime,
          numofman: data.peoplenum,
          activeCode: data.activeCode,
          departmentId: data.departmentId,
          universityId: data.universityId,
          departmentId_dictText: data.departmentId_dictText,
          universityId_dictText: data.universityId_dictText,
        },
      });
    },
    // 查询区域单位改变
    changeuniversity(val) {
      this.universityId = val;
    },
    search() {
      this.getReport();
    },
    // 获取单位列表
    getselectlist() {
      let that = this;
      Axios.get("/university/yhaUniversity/list").then((res) => {
        if (res.data.code == 200) {
          that.universitylist = res.data.result.records;
          if (!localStorage.getItem("teacher_info")) {
            this.universityId = "";
            this.university = "";
          }
        }
      });
    },
    getUniversityId() {
      if (localStorage.getItem("universityId_dictText")) {
        this.university = localStorage.getItem("universityId_dictText");
      }
      if (localStorage.getItem("teacher_info")) {
        this.universityId = JSON.parse(
          localStorage.getItem("teacher_info")
        ).universityId;
      } else {
        this.disabled = false;
      }
    },
    getReport() {
      Axios.get(this.url.alluniverrecord, {
        params: {
          universityId: this.universityId || "",
        },
      }).then((res) => {
        var records = res.data.result.records;
        var allarr = [];
        records.map((item, index) => {
          console.log(item.originalData);
          var arr;
          if (item.step == "1" && JSON.parse(item.originalData).length) {
            console.log(item.originalData);
            var originalData = JSON.parse(item.originalData)[0];
            var obj = {};
            obj.id = item.id;
            obj.departmentId = item.departmentId;
            obj.universityId = item.universityId;
            obj.departmentId_dictText = item.departmentId_dictText;
            obj.universityId_dictText = item.universityId_dictText;
            obj.peoplenum = originalData.参与人数;
            obj.traintime = originalData.训练日期;
            obj.traindepartment =
              originalData.参与院系 || originalData.参与部门;
            obj.activeCode = item.activeCode;
            allarr.push(obj);
          }else {
            var obj = {};
            obj.id = item.id;
            obj.departmentId = item.departmentId;
            obj.universityId = item.universityId;
            obj.departmentId_dictText = item.departmentId_dictText;
            obj.universityId_dictText = item.universityId_dictText;
            obj.peoplenum = '暂无数据';
            obj.traintime = '暂无数据';
            obj.traindepartment = '暂无数据';
            obj.activeCode = item.activeCode;
            allarr.push(obj);
          }
        });
        console.log(allarr);
        this.tableData = allarr;
      });
    },
  },
};
</script>
<style scoped>
.title {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 5vw;
}
@media screen and (min-width: 768px) {
  .title {
    font-size: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: -50px;
    margin-top: 30px;
  }
}
@media screen and (min-width: 768px) {
  .tableContainer {
    width: 50%;
    margin: 0 auto;
  }
}
@media screen and (max-width: 768px) {
  .tableContainer {
    padding: 10px;
  }
}
.searchContainer {
  padding-left: 2%;
}
.searchBtn {
  margin-top: 4px;
  margin-left: 5px;
}
@media screen and (max-width: 768px) {
  .tablebox {
    overflow-x: auto;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/moreRecord/moreRecord.vue